import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
import GitInfo from "react-git-info/macro";
import config from "./config";

const git = GitInfo();

Bugsnag.start({
  apiKey: config.bugsnag.apiKey,
  plugins: [new BugsnagPluginReact()],
  appVersion: `${config.version} - ${git.commit.shortHash}`,
  releaseStage:
    git.branch === "develop2023" && process.env.NODE_ENV === "production"
      ? "production"
      : process.env.NODE_ENV === "production"
      ? "staging"
      : "development",
  enabledReleaseStages: ["production", "staging"],
  autoTrackSessions: false,
});

export const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);
